import React from "react";
import PropTypes from "prop-types";
import SwipeableViews from "react-swipeable-views";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Activetable from "./Activetable";
import Blockedtable from "./Blockedtable";
import SearchBar from "material-ui-search-bar";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Icon from "@material-ui/core/Icon";
import Divider from "@material-ui/core/Divider";
import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";

// import Divider from '@material-ui/core/Divider'

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Typography>{children}</Typography>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background,
    width: "100%",
    "& hr": {
      margin: theme.spacing(1, 0.5),
    },
  },
  Tabs: {
    bgcolor: "whitesmoke",
  },
  Grid: {
    width: "100%",
    alignItems: "center",
    justify: "center",
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    maxWidth: 30,
    maxHeight: 25,
  },
  search: {
    height: 41,
    padding: "2px 4px 0 0",
    display: "flex",
    alignItems: "center",
  },
}));

export default function FullWidthTabs() {
  const classes = useStyles();
  // const theme = useTheme();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // const handleChangeIndex = (index) => {
  //   setValue(index);
  // };

  return (
    <div className={classes.root}>
      <Grid
        container
        p={3}
        direction="row"
        justifyContent="space-around"
        alignItems="center"
        spacing={3}
        className={classes.Grid1}
      >
        <Grid item md={4}></Grid>

        <Grid item md={5} style={{ width: "59%" }}>
          <AppBar
            elevation={0}
            position="static"
            color="white"
            style={{ display: "table-row" }}
          >
            <Tabs value={value} onChange={handleChange}></Tabs>
          </AppBar>
        </Grid>
        <Grid item md={1}></Grid>
        <Grid item md={2}></Grid>
      </Grid>

      <br />
      <Grid item xs={12} sm={12} md={12} lg={12} className={classes.Grid}>
        <TabPanel value={value} index={0}>
          <Activetable />
        </TabPanel>
        {/* <TabPanel value={value} index={1}>
                    <Reportedtable/>
                </TabPanel> */}
        {/* <TabPanel value={value} index={2}>
          <Blockedtable />
        </TabPanel> */}
      </Grid>
    </div>
  );
}
